import type { PromptSegment } from './prompt-segment';
import { escapeHtml } from '../search-input-helper';

// Inverse of parsePrompterHtml: turns the structured prompt back into the chip
// HTML string we inject into the (browser-owned) contentEditable search div.
// Mirrors the markup the retired <PromptTag>/<Prompt> JSX produced, so styling,
// DOM attributes (filter-family-name etc. read by getQueryTextExcludingCatalogTier)
// and click-delegation hooks (data-chip) are unchanged. Atomic chips are
// contenteditable="false" so the browser treats them as single units during edit.

// escapeHtml escapes & < > but not double-quotes; attribute values also need ".
function escapeAttr(value: string): string {
  return escapeHtml(value).replace(/"/g, '&quot;');
}

const TRAILING = '<span class="mx-1">&nbsp;</span>';

function chipHtml(
  classes: string[],
  attrs: Record<string, string>,
  label: string
): string {
  const attrStr = Object.entries(attrs)
    .map(([k, v]) => ` ${k}="${escapeAttr(v)}"`)
    .join('');
  return `<span contenteditable="false" data-chip class="${classes.join(' ')}"${attrStr}>${escapeHtml(label)}</span>`;
}

export function segmentsToHtml(segments: PromptSegment[]): string {
  const parts = segments.map((segment) => {
    if (segment.kind === 'text') {
      return segment.text.trim()
        ? `<span class="mx-1">${escapeHtml(segment.text)}</span>`
        : escapeHtml(segment.text);
    }
    if (segment.kind === 'editable') {
      const id = segment.id === 'narrative' ? 'narrative' : 'lyricscontains';
      return `<span id="${id}" class="font-bold">${escapeHtml(segment.text)}</span>`;
    }

    const classes = ['prompter-tag', 'input-filter-container'];
    const attrs: Record<string, string> = {};
    if (segment.kind === 'artwork') {
      classes.push('input-artwork');
      attrs['artwork-id'] = segment.artworkId;
    } else if (segment.kind === 'artist') {
      classes.push('input-artist');
      attrs['artist-name'] = segment.artistName;
    } else {
      // filter
      if (segment.state === 'green') classes.push('text-green-500');
      if (segment.state === 'red') classes.push('text-red-600');
      if (segment.familyName) attrs['filter-family-name'] = segment.familyName;
      if (segment.state) attrs['filter-state'] = segment.state;
    }
    return chipHtml(classes, attrs, segment.label);
  });

  return parts.join('') + TRAILING;
}
